export const SplashConstant = {
  waitCreating: 'Please wait, we’re creating your account...',
  splashTitle: 'Welcome to Gophr'
};
